import Vue from 'vue';
import VueRouter from 'vue-router';
import contrataYa from '@@/contrata-ya/contrataYa';

Vue.use(VueRouter);

//Componentes

const page = "./components/page/";

const MyRouter = new VueRouter({
	routes: [
		{ path: '/', name: 'homePage', component: require(page + 'home/index.vue').default },
		{ path: '/' + contrataYa.URI + '/:step?', 
			name: 'contrata-ya', 
			component: require(page + 'daniel/contrata-ya/landing.vue').default, 
		},

		{ 
			path: '/legales', 
			name: 'contenido', 
			component: require(page + 'daniel/contenidos/contenido-md.vue').default, 
			meta: { title: "Legales", hash_slug: "legales" },
		},
		{ 
			path: '/tyc', 
			name: 'contenido', 
			component: require(page + 'daniel/contenidos/contenido-md.vue').default, 
			meta: { title: "Terminos y condiciones", hash_slug: "terminos-y-condiciones" },
		},

		{ path: '/c/:hash_slug?', 
			name: 'contenido', 
			component: require(page + 'daniel/contenidos/contenido-md.vue').default, 
		},
		
		{ path: '/contenido/:hash_slug?', 
			name: 'contenido', 
			component: require(page + 'daniel/contenidos/contenido-md.vue').default, 
		},



		// OPENPAY QUICK PAGES
		{ path: '/purchase/complete', component: require(page + 'daniel/view-openpay-success.vue').default, meta: { title: "Pago registrado exitosamente" } },
		{ path: '/purchase/incomplete', component: require(page + 'daniel/view-openpay-fail.vue').default, meta: { title: "Pago no registrado" } },
		{ path: '/purchase/fail', component: require(page + 'daniel/view-openpay-fail.vue').default, meta: { title: "Pago no registrado" } },

		{ path: '/paquetes/movilidad', component: require(page + 'packs/movilidad.vue').default, meta: { title: "Paquete Movilidad" } },
		{ path: '/paquetes/mifi', component: require(page + 'packs/mifi.vue').default, meta: { title: "Paquete MiFi" } },
		{ path: '/paquetes/casa', component: require(page + 'packs/casa.vue').default, meta: { title: "Paquete Casa" } },

		{ path: '/equipos/:page?/:term?', component: require(page + 'products/index.vue').default, meta: { title: "Equipos" } },
		{ path: '/equipo/:id?', component: require(page + 'products/description.vue').default, meta: { title: "Equipo" } },

	    { path: '/cobertura', name: 'cobertura', component: require(page + 'coverage/index.vue').default, meta: { title: "Cobertura" } },
		{ path: '/contacto', component: require(page + 'contact/contacto.vue').default, meta: { title: "Contacto" } },
		{ path: '/sucursales', component: require(page + 'brand-offices/index.vue').default, meta: { title: "Sucursales" } },
		{ path: '/preguntas-frecuentes', component: require(page + 'faqs/index.vue').default, meta: { title: "Preguntas frecuentes" } },
		{ path: '/empresa', component: require(page + 'about-us/index.vue').default, meta: { title: "Empresa" } },
		{ path: '/recargas/:step?', name: 'recargaPage', component: require(page + 'mobile-recharge/index.vue').default, meta: { title: "Recargas" } },

		{
			path: '/portabilidad', component: require(page + 'portability/index.vue').default, meta: { title: "Portabilidad" },
			children: [
				{
					path: '/',
					name: 'portabilityPage',
					component: require(page + 'portability/portability.vue').default,
					meta: { title: 'Portabilidad' }
				},
				{
					path: 'que-es',
					name: 'portabilityPage',
					component: require(page + 'portability/info.vue').default,
					meta: { title: '¿Qué es? | Portabilidad' }
				},
				{
					path: 'pasos-para-la-portabilidad',
					name: 'portabilityPage',
					component: require(page + 'portability/steps.vue').default,
					meta: { title: 'Pasos para la portabilidad | Portabilidad' }
				},
				{
					path: 'preguntas-frecuentes',
					name: 'portabilityPage',
					component: require(page + 'portability/faqs.vue').default,
					meta: { title: 'Preguntas frecuentes | Portabilidad' }
				},
				{
					path: 'enviado',
					name: 'portabilityPage',
					component: require(page + 'portability/form-sent.vue').default,
					meta: { title: 'Portabilidad | Portabilidad' }
				},
			]
		},

		{
			path: '/compatibilidad', component: require(page + 'compatibility/index.vue').default, meta: { title: "Compatibilidad" },
			children: [
				{
					path: '/',
					name: 'compatibilidad',
					component: require(page + 'compatibility/imei.vue').default,
					meta: { title: 'Verificación por IMEI | Compatibilidad' }
				},
				{
					path: 'dispositivos',
					component: require(page + 'compatibility/devices.vue').default,
					meta: { title: 'Dispositivos compatibles | Compatibilidad' }
				},
			]
		},

		{
			path: '/glosario', component: require(page + 'glossary/index.vue').default, meta: { title: "Glosario" },
			children: [
				{
					path: '/',
					name: 'glossarySIMPage',
					component: require(page + 'glossary/simcard.vue').default,
					meta: { title: 'Número telefónico y SIM CARD | Glosario' }
				},
				{
					path: 'portabilidad-numerica',
					name: 'glossaryNUMPage',
					component: require(page + 'glossary/number.vue').default,
					meta: { title: '¿Qué es la portabilidad numérica? | Glosario' }
				},
				{
					path: 'coberturas',
					name: 'glossaryCOBPage',
					component: require(page + 'glossary/coberturas.vue').default,
					meta: { title: 'Coberturas | Glosario' }
				},
			]
		},

		{ path: '/contrato-marco-de-prestacion-de-servicios-de-telecomunicaciones', component: require(page + 'text-page/contrato-marco-prestacion-servicios.vue').default, meta: { title: "Contrato marco de prestación de servicios de telecomunicaciones" } },
		{ path: '/codigo-de-politicas-de-gestion-de-trafico-y-administracion-de-red', component: require(page + 'text-page/codigo-politicas-gestion.vue').default, meta: { title: "Código de políticas de gestión de tráfico y administración de red" } },
		{ path: '/carta-de-derechos-de-los-usuarios-ift-y-profeco', component: require(page + 'text-page/carta-derechos-usuarios.vue').default, meta: { title: "Carta de Derechos de los Usuarios IFT y Profeco" } },
		{ path: '/codigo-de-practicas-comerciales', component: require(page + 'text-page/codigo-practicas-comerciales.vue').default, meta: { title: "Codigo de prácticas comerciales" } },
		{ path: '/informacion-sobre-colaboracion-en-materia-de-seguridad-y-justicia', component: require(page + 'text-page/colaboracion-justicia.vue').default, meta: { title: "Información sobre colaboración en materia de seguridad y justicia" } },
		{ path: '/aviso-de-inicio-de-operaciones-BLACKFON-MX', component: require(page + 'text-page/aviso-de-operaciones.vue').default, meta: { title: "Aviso de Inicio de Operaciones BLACKFON-MX" } },
		{ path: '/oficio-de-aprobacion', component: require(page + 'text-page/oficio-de-aprobacion.vue').default, meta: { title: "Oficio de Aprobación del Contrato de Adhesión" } },
		{ path: '/terminos-y-condiciones', component: require(page + 'text-page/terminos.vue').default, meta: { title: "Términos y condiciones" } },

		// { path: '/tutoriales', name: 'tutoPage', component: require(page + 'tutorials/index.vue').default, meta: { title: "Tutoriales" } },
		// { path: '/tutoriales/:id?', component: require(page + 'tutorials/detail.vue').default, meta: { title: "Tutorial" } },

		{ path: '/pages', name: 'blogPage', component: require(page + 'pages/index.vue').default, meta: { title: "Contenidos" } },
		{ path: '/pages/:id?', component: require(page + 'pages/description.vue').default, meta: { title: "Detalles del contenido" } },

		{ path: '/cart/:step?', component: require(page + 'carrito/index.vue').default, meta: { title: "Mi carrito de compras" } },
		{ path: '/historial-de-compras', component: require(page + 'carrito/historial.vue').default, meta: { title: "Mi historial de compras" } },
		// { path: '/mis-favoritos', component: require(page+'carrito/mis-favoritos.vue').default, meta:{title:"Mis favoritos"}},

		{ path: '/login', name: 'Login', component: require(page + 'user-access/login.vue').default, meta: { title: "Iniciar sesión" } },
		{ path: '/registrarse', name: 'SignUp', component: require(page + 'user-access/register.vue').default, meta: { title: "Registrarse" } },
		{ path: '/recuperar-contrasena', component: require(page + 'user-access/reset-password.vue').default, meta: { title: "Recuperar contraseña" } },

		{
			path: '/usuario', 
			component: require(page + 'usuario-cuenta/index.vue').default, 
			meta: { title: 'Mi datos' },
			children: [
				{
					path: 'mis-datos',
					component: require(page + 'usuario-cuenta/mis-datos.vue').default,
					meta: { title: 'Mis datos' }
				},
				{
					path: 'mis-pedidos',
					component: require(page + 'usuario-cuenta/mis-pedidos.vue').default,
					meta: { title: 'Mis datos' }
				},
				{
					path: 'contrasena',
					component: require(page + 'usuario-cuenta/contrasena.vue').default,
					meta: { title: 'Cambiar contraseña' }
				},
				{
					name: 'mis-numeros',
					path: 'numeros',
					name: 'Mi cuenta',
					component: require(page + 'usuario-cuenta/saldo.vue').default,
					meta: { title: 'Mis numeros BlackFon®' }
				},
				{
					name: 'mis-suscripciones',
					path: 'suscripciones/:suscId?',
					component: require(page + 'usuario-cuenta/suscripciones.vue').default,
					meta: { title: 'Mis suscripciones BlackFon®' }
				},
				{
					path: 'ordenes-de-pago',
					component: require(page + 'usuario-cuenta/usuario-invoices-stripe.vue').default,
					meta: { title: 'Ordenes de pago' }
				},
				{
					path: 'metodos-pago',
					component: require(page + 'usuario-cuenta/metodos-pago-stripe.vue').default,
					meta: { title: 'Mis métodos de pago' }
				},
				// {
				// 	path: 'historial-pagos',
				// 	component: require(page+'usuario-cuenta/historial-pagos.vue').default,
				// 	meta:{ title: 'Historial de recargas' }
				// },
				// {
				// 	path: 'pagar-factura',
				// 	component: require(page+'usuario-cuenta/pagar-factura.vue').default,
				// 	meta:{ title: 'Paga tu factura online' }
				// },
				// {
				// 	path: 'soporte',
				// 	component: require(page+'usuario-cuenta/soporte.vue').default,
				// 	meta:{ title: 'Soporte' }
				// },
			]
		}

		// { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0, 0);
	if (window.app.__vue__ && window.app.__vue__.$refs.loadingBar) {
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if (window.app.__vue__ && window.app.__vue__.$refs.loadingBar) {
		setTimeout(() => {
			window.app.__vue__.$refs.loadingBar.done();
		}, 500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "BlackFon, la red mas exclusiva", filter: (title) => { return title + " - BlackFon, la red mas exclusiva"; } }
);

// export {routes};
export default MyRouter;
